module.exports = __webpack_public_path__ + "img/demo.b0481892.png";